import React, { useState } from 'react';
import moment from 'moment';
import { useLocation, useHistory } from 'react-router-dom';

import ContainerFlex from '~/components/containerFlex';
import Dialog from '~/components/dialog';

import { icons } from '~/assets';
import Container from '~/components/container';

import * as St from '../style';
import InfoDetailsCampaing from './components/InfoDetailsCampaing';
import Select from '~/components/select';
import RadioButton from '~/components/radioButton';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Button from '~/components/button';
import useApi, { ApiMethod } from '~/hooks/useApi';
import Endpoints from '~/services/endpoints';
import Loading from '~/components/loading';
import Input from '~/components/input';
import ViewMockPushMobile from './components/viewMockPushMobile';
import { IResponseDetailsCampaing } from './models/interfaceModels';
import { stat } from 'fs';

const ChannelOptions = [
  { id: 'PUSH', name: 'Push notification', value: 'Push notification' },
  //   { id: 'EMAIL_HTML', name: 'Email HTML', value: 'Email HTML' },
];

const DefineActionsCommunication: React.FC = () => {
  const history = useHistory();
  const { state } = useLocation<{
    idCampaing: string;
    dataCampaing: IResponseDetailsCampaing;
    templateMensagem: {
      titulo: string;
      mensagem: string;
    };
  }>();
  const [infoDialog, setInfoDialog] = useState({
    open: false,
    message: '',
    error: false,
    isGoBack: false,
  });
  const [sendMessage, setSendMessage] = useState(true);
  const [channel, setChannel] = useState('PUSH');
  const [valueMessage, setValueMessage] = useState('');
  const [form, setForm] = useState<{
    titleMessage: string;
    bodyMessage: string;
  }>({
    titleMessage: state?.templateMensagem?.titulo || '',
    bodyMessage: state?.templateMensagem?.mensagem || '',
  });
  const [dialogIsOpen, setDialogIsOpen] = useState(false);

  const POSTIncludeMessageCampaign = useApi(
    Endpoints.fidelizacao.postIncludeMessageCampaign.replace(
      'PARAM_ID_CAMPANHA',
      state?.idCampaing,
    ),
    ApiMethod.POST,
  );

  const POSTExecuteCampaignV2 = useApi(
    Endpoints.fidelizacao.postExecuteCampaignV2.replace(
      'PARAM_ID_CAMPANHA',
      state?.idCampaing,
    ),
    ApiMethod.POST,
  );

  /**
   * Função para salvar as ações de comunicação da campanha.
   * @return {void}
   */
  const saveCommunicationActions = async () => {
    try {
      const payload = {
        canal: channel || null,
        acao: 'DISPARO_MENSAGEM',
        dataDisparoAgendado: state?.dataCampaing?.dataAgendamento || null, // Necessário apenas se for agendado
        templateMensagem: {
          titulo: form.titleMessage.trim(),
          mensagem: form.bodyMessage.trim(),
        },
      };

      const response = await POSTIncludeMessageCampaign.callApi(payload);

      if (response.status >= 200 && response.status < 300) {
        const mensagemSucesso = state?.dataCampaing?.dataAgendamento
          ? 'Ações de comunicação salvas com sucesso! Campanha agendada para ' +
            moment(state.dataCampaing.dataAgendamento).format(
              'DD/MM/YYYY HH:mm',
            )
          : 'Ações de comunicação salvas com sucesso!';
        setInfoDialog({
          open: true,
          message: mensagemSucesso,
          error: false,
          isGoBack: state?.dataCampaing?.dataAgendamento ? true : false,
        });
      } else {
        setInfoDialog({
          open: true,
          message:
            response.mensagem ||
            'Ocorreu um erro ao salvar as ações de comunicação.',
          error: true,
          isGoBack: false,
        });
      }
    } catch (error) {
      setInfoDialog({
        open: true,
        message: 'Ocorreu um erro ao salvar as ações de comunicação.',
        error: true,
        isGoBack: false,
      });
    }
  };

  /**
   * Função para executar a campanha.
   */
  const executeCampaign = async () => {
    try {
      const response = await POSTExecuteCampaignV2.callApi();

      if (response.status >= 200 && response.status < 300) {
        setInfoDialog({
          open: true,
          message: 'Campanha executada com sucesso!',
          error: false,
          isGoBack: true,
        });
      } else {
        setInfoDialog({
          open: true,
          message:
            response.mensagem || 'Ocorreu um erro ao executar a campanha.',
          error: true,
          isGoBack: false,
        });
      }
    } catch (error) {
      setInfoDialog({
        open: true,
        message: 'Ocorreu um erro ao executar a campanha.',
        error: true,
        isGoBack: false,
      });
    }
  };

  const handleDisableBtnExecuteCampaign = (): boolean => {
    if (
      state?.templateMensagem?.titulo.trim() === '' &&
      state?.templateMensagem?.mensagem.trim() === ''
    ) {
      if (
        POSTIncludeMessageCampaign.status >= 200 &&
        POSTIncludeMessageCampaign.status < 300
      ) {
        return false;
      } else {
        return true;
      }
    }

    if (
      state?.templateMensagem?.titulo.trim() !== form.titleMessage.trim() ||
      state?.templateMensagem?.mensagem.trim() !== form.bodyMessage.trim()
    ) {
      if (
        POSTIncludeMessageCampaign.status >= 200 &&
        POSTIncludeMessageCampaign.status < 300
      ) {
        return false;
      } else {
        return true;
      }
    }

    if (form.titleMessage.trim() === '' || form.bodyMessage.trim() === '') {
      return true;
    }

    if (
      POSTExecuteCampaignV2.status >= 200 &&
      POSTExecuteCampaignV2.status < 300
    ) {
      return true;
    }

    return false;
  };

  return (
    <>
      <Loading
        status={
          POSTIncludeMessageCampaign.loading || POSTExecuteCampaignV2.loading
        }
      />
      <Dialog
        icon={infoDialog.error ? icons.exclamation : icons.check}
        open={infoDialog?.open}
        title="Detalhes"
        widthInPercent={40}
        positiveLabel="Entendi"
        positiveAction={() => {
          setInfoDialog({
            message: '',
            open: false,
            error: false,
            isGoBack: false,
          });
          if (infoDialog.isGoBack) {
            history.push('/campanha');
          }
        }}
        message={infoDialog?.message}
      />
      <Dialog
        widthInPercent={70}
        open={dialogIsOpen}
        positiveLabel="Concluir"
        positiveAction={() => {
          setDialogIsOpen(false);
        }}
        icon={icons.check}
        title="Visualização da push notification"
      >
        <ContainerFlex center horizontal>
          <ViewMockPushMobile
            title={form.titleMessage}
            text={form.bodyMessage}
          />
        </ContainerFlex>
      </Dialog>
      <Container>
        <St.BoxCard>
          <St.Title style={{ marginBottom: '2%' }}>
            Detalhes da campanha
          </St.Title>
          <ContainerFlex>
            <ContainerFlex marginLeft={8}>
              <InfoDetailsCampaing
                data={state?.dataCampaing}
                isDefineCommunication
              />
            </ContainerFlex>

            <ContainerFlex marginTop={20}>
              <St.Title style={{ marginBottom: '1%' }}>Definir ações</St.Title>
            </ContainerFlex>

            <ContainerFlex marginLeft={8}>
              <ContainerFlex row center key={'sendMsg'}>
                <RadioButton
                  id={'sendMsg'}
                  name={'sendMsg'}
                  checked={sendMessage}
                  onClick={() => setSendMessage(!sendMessage)}
                  disabled={
                    POSTIncludeMessageCampaign.status >= 200 &&
                    POSTIncludeMessageCampaign.status < 300
                  }
                />
                Disparo de mensagem
              </ContainerFlex>

              <ContainerFlex marginTop={30} maxWidth={30}>
                <Select
                  label="Canal"
                  options={ChannelOptions}
                  name="Canal"
                  value={channel}
                  onChange={(selectedOption) => {
                    setChannel(selectedOption);
                  }}
                  disabled={
                    POSTIncludeMessageCampaign.status >= 200 &&
                    POSTIncludeMessageCampaign.status < 300
                  }
                />
              </ContainerFlex>

              <ContainerFlex marginTop={20}>
                <St.Title style={{ marginBottom: '1%' }}>
                  Definir Mensagem
                </St.Title>
              </ContainerFlex>
              {channel === 'EMAIL_HTML' ? (
                <ContainerFlex marginLeft={8}>
                  <ReactQuill
                    theme="snow"
                    value={valueMessage}
                    onChange={setValueMessage}
                    style={{ height: '200px', maxHeight: '200px' }}
                    readOnly={
                      POSTIncludeMessageCampaign.status >= 200 &&
                      POSTIncludeMessageCampaign.status < 300
                    }
                  />
                </ContainerFlex>
              ) : (
                <ContainerFlex row wrap marginLeft={8} maxWidth={95}>
                  <ContainerFlex>
                    <Input
                      label="Titulo da mensagem"
                      placeholder="Digite o título da mensagem"
                      value={form.titleMessage}
                      onChange={(e) => {
                        return setForm({
                          ...form,
                          titleMessage: e.target.value,
                        });
                      }}
                    />
                  </ContainerFlex>
                  <ContainerFlex marginLeft={20}>
                    <Input
                      label="Corpo da mensagem"
                      placeholder="Digite o corpo da mensagem"
                      value={form.bodyMessage}
                      onChange={(e) => {
                        return setForm({
                          ...form,
                          bodyMessage: e.target.value,
                        });
                      }}
                    />
                  </ContainerFlex>
                </ContainerFlex>
              )}

              <ContainerFlex row end marginTop={60} marginRight={20}>
                <Button
                  borderRadius={10}
                  fitContent
                  onClick={() => setDialogIsOpen(true)}
                >
                  <span>Visualizar</span>
                </Button>
                <Button
                  borderRadius={10}
                  fitContent
                  marginLeft={10}
                  onClick={() => {
                    saveCommunicationActions();
                  }}
                  disabled={
                    channel === 'EMAIL_HTML'
                      ? valueMessage === ''
                      : form.titleMessage === '' || form.bodyMessage === ''
                  }
                >
                  <span>Salvar</span>
                </Button>
              </ContainerFlex>

              <ContainerFlex row end marginTop={60}>
                <Button
                  borderRadius={10}
                  fitContent
                  onClick={() => history.goBack()}
                >
                  <span>Voltar</span>
                </Button>
                {state?.dataCampaing?.dataAgendamento ? null : (
                  <Button
                    borderRadius={10}
                    fitContent
                    marginLeft={10}
                    onClick={() => {
                      executeCampaign();
                    }}
                    disabled={handleDisableBtnExecuteCampaign()}
                  >
                    <span>Executar</span>
                  </Button>
                )}
              </ContainerFlex>
            </ContainerFlex>
          </ContainerFlex>
        </St.BoxCard>
      </Container>
    </>
  );
};

export default DefineActionsCommunication;
